import {
  downloadReportAttributes,
  downloadReportRequestBody,
} from "../features/reports/types/types";
import { downloadReport, getReport, task } from "./reportService";
import { openPopup } from "../stateManagement/actions/popupActions";
import { ChannelkartNetworkGet } from "./networkService";
import moment from "moment";
import { Dayjs } from "dayjs";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { string } from "yup";
import { DownloadSingleReportConfig } from "../types/types";

export async function GetAllReportInfo(): Promise<any> {
  const response = await ChannelkartNetworkGet("/v1/registry/data/ReportInfo");
  return response.data;
}

const download = async (id: string) => {
  if (getReport) await getReport(id);
};

const downloadReportWithStatus = async (
  id: string,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setSnackbarOpen(true);
  if (task) {
    const res = await task(id);
    let data = res.data.features[0];
    if (data.status === "SUCCESS") {
      download(id);
      setSnackbarOpen(false);
    } else if (data.status === "INPROGRESS") {
      await new Promise((resolve) => setTimeout(resolve, 2000)); 
      await downloadReportWithStatus(id, setSnackbarOpen)
    } else {
      setSnackbarOpen(false);
      openPopup("Error", "Something went wrong while downloading the report!");
    }
  }
};
const downloadSingleReportWithStatus = async (
  id: string,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownload: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setSnackbarOpen(true);
  if (task) {
    const res = await task(id);
    let data = res.data.features[0];
    if (data.status === "SUCCESS") {
      download(id);
      setSnackbarOpen(false);
       setIsDownload(false);
    } else if (data.status === "INPROGRESS") {

      await new Promise((resolve) => setTimeout(resolve, 2000)); 
      await downloadSingleReportWithStatus(id, setSnackbarOpen, setIsDownload);
    } else {
      setSnackbarOpen(false);
      setIsDownload(false);
      openPopup("Error", "Something went wrong while downloading the report!");
    }
  }else {
    setIsDownload(false); // Reset if task is unavailable
    openPopup("Error", "Task service unavailable!");
  }
};
const downloadGrnReportWithStatus = async (
  id: string,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setSnackbarOpen(true);
  if (task) {
    const res = await task(id);
    let data = res.data.features[0];
    if (data.status === "SUCCESS") {
      download(id);
      setSnackbarOpen(false);
      setIsDownloading(false);
    } else if (data.status === "INPROGRESS") {
      await new Promise((resolve) => setTimeout(resolve, 2000)); 
      await downloadGrnReportWithStatus(id, setSnackbarOpen, setIsDownloading);
    } else {
      setSnackbarOpen(false);
      setIsDownloading(false);
      openPopup("Error", "Something went wrong while downloading the report!");
    }
  }else {
    setIsDownloading(false); // Reset if task is unavailable
    openPopup("Error", "Task service unavailable!");
  }
};

const startProcessingReport = async (
  requestBody: downloadReportRequestBody,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (Object.keys(requestBody).length > 0) {
    const response = await downloadReport(requestBody);
    await downloadReportWithStatus(response.data.id, setSnackbarOpen);
  }
};
const startProcessingSingleReport = async (
  requestBody: downloadReportRequestBody,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownload:React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (Object.keys(requestBody).length > 0) {
    const response = await downloadReport(requestBody);
    await downloadSingleReportWithStatus(response.data.id, setSnackbarOpen,setIsDownload);
  }
};

const startProcessingGrnReport = async (
  requestBody: downloadReportRequestBody,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (Object.keys(requestBody).length > 0) {
    const response = await downloadReport(requestBody);
    await downloadGrnReportWithStatus(response.data.id, setSnackbarOpen,setIsDownloading);
  }
};

export const downloadSingleReport = async (
  config: DownloadSingleReportConfig,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownload : React.Dispatch<React.SetStateAction<boolean>>,
  setErrorReason?: React.Dispatch<React.SetStateAction<String>>,
  isPrimaryOrder?: boolean,
  reportDownloadSuccess?: React.MutableRefObject<boolean>,
) => {
  const { reportId, filters } = config;

  if (reportId === null) {
    openPopup(
      "Error",
      "Report ID in config is invalid. Enter correct ID in config to download report"
    );
    setIsDownload(false); 
    if (reportDownloadSuccess) reportDownloadSuccess.current = false
    return;
  }

  const filterPayload = {
    filters,
    operator: "and",
  };

  if (isPrimaryOrder){
    config.filters.push({
      key: "type", 
      value: "primary"
    })
  };

  let newAttributes: downloadReportAttributes = {
    name: reportId,
    format: "xlsx",
    filter: filterPayload,
    loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
  };

  let requestBody: downloadReportRequestBody = {
    attributes: newAttributes,
    lob: EnvironmentRegistry.getCurrentLob() ?? "",
  };
  try {
    await startProcessingSingleReport(requestBody, setSnackbarOpen, setIsDownload);
  } catch (e: any) {
    if (setErrorReason) {
      setErrorReason(e.toString())
    }
    setIsDownload(false); // Reset on error in starting process
    if (reportDownloadSuccess) reportDownloadSuccess.current = false
    openPopup("Error", "Something went wrong while downloading the report!");
  }
};

export const downloadGrnReport = async (
  reportId: string | null,
  filterKey: string,
  filterValue: string,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (reportId === null) {
    openPopup(
      "Error",
      "Report ID in config is invalid. Enter correct ID in config to download report"
    );
    setIsDownloading(false); 
    return;
  }

  const filter = {
    filters: [
      {
        key: filterKey,
        value: filterValue,
      },
    ]
  };

  let newAttributes: downloadReportAttributes = {
    name: reportId,
    format: "pdf",
    filter: filter,
    loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
  };

  let requestBody: downloadReportRequestBody = {
    attributes: newAttributes,
    lob: EnvironmentRegistry.getCurrentLob() ?? "",
  };

  try {
    await startProcessingGrnReport(requestBody, setSnackbarOpen, setIsDownloading);
  } catch (e) {
    setIsDownloading(false); // Reset on error in starting process
    openPopup("Error", "Something went wrong while downloading the report!");
  }
};

export const downloadAllReports = async (
  reportId: string | null,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  startDate?: Dayjs,
  endDate?: Dayjs,
  filterKey?: string,
  filterValue?: any,
  loggedInUserName?: string
) => {
  if (reportId === null) {
    openPopup(
      "Error",
      "Report ID in config is invalid. Enter correct ID in config to download report"
    );
    return;
  }

  let attributes: downloadReportAttributes = {
    name: reportId,
    format: "xlsx",
    loggedInUserName: loggedInUserName || JSON.parse(localStorage.authContext).user.loginId,
  };
  if (filterKey && filterValue) {
    attributes.filter = {
      filters: [
        {
          key: filterKey,
          value: filterValue,
        },
      ],
      operator: "and",
    }
  }

  if (startDate != null && endDate != null) {
    attributes = {
      ...attributes,
      fromDate: moment(startDate.toISOString()).format("YYYY-MM-DD 00:00:00"),
      toDate: moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59")
    }
  }

  const requestBody: downloadReportRequestBody = {
    attributes,
    lob: EnvironmentRegistry.getCurrentLob() ?? "",
  };

  await startProcessingReport(requestBody, setSnackbarOpen);
};


export const downloadAllReportsPrimarySecondary = async (
  reportId: string | null,
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  startDate: Dayjs,
  endDate: Dayjs,
  filterKey: string,
  filterValue: any,
  setIsDownload : React.Dispatch<React.SetStateAction<boolean>>,
  downloadSingleReportConfig?: DownloadSingleReportConfig | null,
  checkedOrderNumbers?: string[],
  rows?: any[]
) => {
  if (reportId === null) {
    openPopup(
      "Error",
      "Report ID in config is invalid. Enter correct ID in config to download report"
    );
    return;
  }

  let attributes: downloadReportAttributes;
  let downloadCheckedOrderNumber: boolean = !!(downloadSingleReportConfig && ((checkedOrderNumbers?.length || 0) > 0) && rows);
  if (downloadCheckedOrderNumber) {
    const filteredRows = rows?.filter(r => checkedOrderNumbers?.includes(r?.id));

    attributes = {
      name: downloadSingleReportConfig?.reportId ?? "",
      format: "xlsx",
      filter: {
          filters: filteredRows?.flatMap((row) => {
          return (downloadSingleReportConfig?.filters ?? []).map((filter) => {
            const filterValueKey = filter?.key ?? "";
            const filterValue = row?.[filterValueKey] ?? "";
            return { key: filterValueKey, value: filterValue };
          });
        }),
        operator: "and",
      },
      loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
    };
  } else {
    attributes = {
      name: reportId,
      format: "xlsx",
      loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
    };
  }

  if (filterKey && filterValue && !downloadCheckedOrderNumber) {
    attributes.filter = {
      filters: [
        {
          key: filterKey,
          value: filterValue,
        },
      ],
      operator: "and",
    }
  }

  if (startDate != null && endDate != null && !downloadCheckedOrderNumber) {
    attributes = {
      ...attributes,
      fromDate: moment(startDate.toISOString()).format("YYYY-MM-DD 00:00:00"),
      toDate: moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59")
    }
  }

  const requestBody: downloadReportRequestBody = {
    attributes,
    lob: EnvironmentRegistry.getCurrentLob() ?? "",
  };
  try {
    await startProcessingSingleReport(requestBody, setSnackbarOpen, setIsDownload);
  } catch (e) {
    setIsDownload(false); // Reset on error in starting process
    openPopup("Error", "Something went wrong while downloading the report!");
  }
  // await startProcessingReport(requestBody, setSnackbarOpen);
};
